export enum SCREENS {
  fontList = 'fontList',
  categoryList = 'categoryList',
  fontEdit = 'fontEdit',
}
